import { DateTime } from 'luxon';

export interface ExamDates {
  [exam: string]: DateTime[];
}

export const examDates: ExamDates = {
  GSSE: [
    // DateTime.fromISO('2024-12-12'),
    // DateTime.fromISO('2025-02-12'),
    DateTime.fromISO('2025-06-11'),
    DateTime.fromISO('2025-10-08'),
    DateTime.fromISO('2026-02-11'),
    DateTime.fromISO('2026-06-11'),
  ],
  // TODOEXAM
  BPS: [
    // DateTime.fromISO('2024-05-02'),
    DateTime.fromISO('2025-05-02'),
    DateTime.fromISO('2026-05-02'),
    DateTime.fromISO('2027-05-02'),
  ],
  // GPEPAU: [],
  // GPEPNZ: []

}

const exams =  Object.keys(examDates)

export const getCurrentExam = () => {
  return exams.find(e => e === window.location.pathname.split('/')[1] || window.location.pathname.split('/')[1].toUpperCase() === e);
}


window.location.pathname.match(/^\/([^/]+)\//)

console.log(exams)
console.log(window.location.pathname)

//TODOEXAM use examdate and then refactor to use this shared method,
//then in the auth modal use this
//also consider a react router navite solution
//may need to be a hook with useLocation.
// const examMatch = location.pathname.match(/^\/([^/]+)\//);

export const freeExams = ["BPS"];
